import find from 'lodash/find';

import {DEFAULT_PAGE_SIZE} from '../utils/constants';

import type {TeamsFetchParamsType, TeamsLocationParamsType} from './types';
import type {
  BasicTeamSerializedType,
  RelatedTeamsSerializedType,
  TeamSerializedType,
  UserSerializedType,
  UserTeamMembershipSerializedType,
  UserTeamSerializedType,
} from 'sweet-types';

export const getMembership = (
  user: UserSerializedType,
  team: TeamSerializedType | UserTeamSerializedType
): undefined | UserTeamMembershipSerializedType => {
  return find(user.team_memberships, {team: team.url});
};
export const convertLocationParamsToFetchParams = (
  query: TeamsLocationParamsType
): TeamsFetchParamsType => ({
  page: query.page != null ? query.page : '1',
  page_size: query.page_size != null ? query.page_size : `${DEFAULT_PAGE_SIZE}`,
  search: query.search != null ? query.search : undefined,
  ordering: query.ordering,
  user_id: query.user_id,
  exclude_user_id: query.exclude_user_id,
  id: query.id,
  document_url: query.document_url,
});

export const getBasicTeamsFromRelated = (
  procedure: {
    team_names: Array<{type: 'basic_team'; id: number}>;
  },
  related?: RelatedTeamsSerializedType
) => {
  return related != null
    ? procedure.team_names.map<BasicTeamSerializedType>(
        ({id}) => related.basic_team[id.toString()]
      )
    : [];
};
